import "./sections/header";
import "./components/swipers";

if (document.querySelector(".product-data__container")) {
  const viewThumbs = document.querySelectorAll(".product-data__thumb");
  const mediaContainer = document.querySelector(
    ".product-data__media-container"
  );

  const productMedia = window.productMediaData || [];

  viewThumbs.forEach((thumb, index) => {
    thumb.addEventListener("click", () => {
      const mediaIndex = parseInt(thumb.getAttribute("data-media-index"));
      const mediaType = thumb.getAttribute("data-media-type");

      viewThumbs.forEach((item) => {
        item.classList.remove("active");
      });

      thumb.classList.add("active");

      renderMedia(mediaIndex, mediaType);
    });
  });

  function renderMedia(index, type) {
    if (!productMedia[index]) {
      console.error("Media not found at index:", index);
      return;
    }

    const media = productMedia[index];

    mediaContainer.innerHTML = "";
    mediaContainer.setAttribute("data-media-type", type);

    try {
      switch (type) {
        case "image":
          const imageUrl = media.src || media.url;
          mediaContainer.innerHTML = `
            <figure class="product-data__media--figure">
              <img 
                src="${imageUrl}" 
                alt="${media.alt || "Product image"}" 
                loading="eager"
                width="800"
                height="${Math.round(800 / (media.aspect_ratio || 1))}"
                data-media-index="${index}"
              >
            </figure>
          `;
          break;

        case "video":
          let posterUrl = "";
          if (media.preview_image) {
            posterUrl = media.preview_image.src || media.preview_image;
          }

          let videoUrl = "";
          if (media.sources && media.sources.length > 0) {
            videoUrl = media.sources[0].url;
          }

          mediaContainer.innerHTML = `
            <div class="product-data__media--video" data-media-index="${index}">
              <video 
                controls
                ${posterUrl ? `poster="${posterUrl}"` : ""}
                width="800"
                height="${Math.round(800 / (media.aspect_ratio || 1))}"
              >
                ${videoUrl ? `<source src="${videoUrl}" type="video/mp4">` : ""}
                Your browser does not support the video tag.
              </video>
            </div>
          `;
          break;

        case "external_video":
          const externalId = media.external_id;
          mediaContainer.innerHTML = `
            <div class="product-data__media--external-video" data-media-index="${index}">
              <iframe 
                src="https://www.youtube.com/embed/${externalId}?autoplay=1"
                width="800"
                height="${Math.round(800 / (media.aspect_ratio || 1))}"
                frameborder="0"
                allowfullscreen
              ></iframe>
            </div>
          `;
          break;

        case "model":
          let modelUrl = "";
          let modelPoster = "";

          if (media.sources && media.sources.length > 0) {
            modelUrl = media.sources[0].url;
          }

          if (media.preview_image) {
            modelPoster = media.preview_image.src || media.preview_image;
          }

          mediaContainer.innerHTML = `
            <div class="product-data__media--model" data-media-index="${index}">
              <model-viewer
                src="${modelUrl}"
                ${modelPoster ? `poster="${modelPoster}"` : ""}
                camera-controls
                auto-rotate
                ar
                style="width: 800px; height: ${Math.round(
                  800 / (media.aspect_ratio || 1)
                )}px;"
              ></model-viewer>
            </div>
          `;
          break;

        default:
          console.warn("Unknown media type:", type);
      }
    } catch (error) {
      console.error("Error rendering media:", error);
      mediaContainer.innerHTML = `
        <div class="media-error">
          <p>Error loading media</p>
        </div>
      `;
    }
  }

  if (viewThumbs.length > 0) {
    viewThumbs[0].classList.add("active");
  }
}
